import { useMutation } from '@tanstack/react-query'
import { updateLanguagePreference } from '@/api/currentUserApi'

/**
 * Persists the user's selected content language to their profile so it follows them
 * to new browsers/sessions. Fire-and-forget from the language selector — a failure
 * leaves the local (persisted) selection intact; it just won't sync cross-device.
 */
export function useUpdateLanguagePreference() {
  return useMutation({
    mutationFn: (languageCode: string) => updateLanguagePreference(languageCode),
    onError: (err) => {
      console.warn('[Language] Failed to persist language preference:', err)
    },
  })
}
